import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import Login from './components/Auth/Login';
import Sidebar from './components/Layout/Sidebar';
import Header from './components/Layout/Header';
import SubirExcel from './components/Proyectos/SubirExcel';
import ListaProyectos from './components/Proyectos/ListaProyectos';
import DetalleProyecto from './components/Proyectos/DetalleProyecto';
import ProyectosEspeciales from './components/Proyectos/ProyectosEspeciales';
import ProyectosLiquidados from './components/Proyectos/ProyectosLiquidados';
import Polizas from './components/Polizas/Polizas';
import Proveedores from './components/Proveedores/Proveedores';
import DetalleProveedor from './components/Proveedores/DetalleProveedor';
import TiposProveedor from './components/Proveedores/TiposProveedor';
import Pagos from './components/Pagos/Pagos';
import InventarioBodega from './components/Bodega/InventarioBodega';
import EntradasBodega from './components/Bodega/EntradasBodega';
import SalidasBodega from './components/Bodega/SalidasBodega';
import Usuarios from './components/Acceso/Usuarios';
import CarteraList from './components/Cartera/CarteraList';
import HojaVidaDetalle from './components/Cartera/HojaVidaDetalle';
import CuentasCobro from './components/Documentos/CuentasCobro';
import Contratos from './components/Documentos/Contratos';
import MatrizActividades from './components/Documentos/MatrizActividades';
import Cotizaciones from './components/Documentos/Cotizaciones';
import Planos from './components/Documentos/Planos';
import FichaFFE from './components/Documentos/FichaFFE';
import CarritoComprasGeneral from './components/Documentos/CarritoComprasGeneral';
import Contabilidad from './components/Documentos/Contabilidad';
import Residentes from './components/Residentes/Residentes';
import Enchapes from './components/Enchapes/Enchapes';
import ConceptosFacturas from './components/Administrativo/ConceptosFacturas';
import AlertasAdmin from './components/Alertas/AlertasAdmin';
import Posventa from './components/Posventa/Posventa';
import CRMComercial from './components/CRM/CRMComercial';
import FormulasCarrito from './components/FormulasCarrito/FormulasCarrito';
import InformesComerciales from './components/InformesComerciales/InformesComerciales';
import CatalogoFFE from './components/CatalogoFFE/CatalogoFFE';
import CronogramaGeneral from './components/Proyectos/CronogramaGeneral';
import MisCompromisos from './components/Proyectos/MisCompromisos';
import Ingenieros from './components/Ingenieros/Ingenieros';
import CajaMenor from './components/CajaMenor/CajaMenor';
import CajaMenorAdministrativo from './components/CajaMenor/CajaMenorAdministrativo';
import Facturas from './components/Facturas/Facturas';
import SeguimientoComercial from './components/Gerencia/SeguimientoComercial';
import Marketing from './components/Gerencia/Marketing';
import Tecnico from './components/Gerencia/Tecnico';
import TableroGerencial from './components/Gerencia/TableroGerencial';
import VistaFinancieraGerencia from './components/Gerencia/VistaFinancieraGerencia';
import EditorPlanos from './components/Planos/EditorPlanos';
import Configurador3DDemo from './components/Muebles3D/Configurador3DDemo';
import './App.css';

// Módulos que usan ancho completo (tablas anchas, sin límite de 1400px)
const MODULOS_ANCHOS = ['matriz-actividades'];

// Componente principal de la aplicación (protegido)
function AppContent() {
  const { user, logout, loading } = useAuth();
  const [activeModule, setActiveModule] = useState('lista-proyectos');
  const [selectedProyecto, setSelectedProyecto] = useState(null);
  // Contexto para abrir el módulo Posventa mostrando el gasto de un apartamento
  const [posventaCtx, setPosventaCtx] = useState(null);
  const [selectedProveedor, setSelectedProveedor] = useState(null);
  const [selectedHojaVida, setSelectedHojaVida] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Detectar parámetro ?proyecto=ID en la URL para acceso directo
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const proyectoId = params.get('proyecto');
    if (proyectoId) {
      setSelectedProyecto(parseInt(proyectoId));
      setActiveModule('detalle-proyecto');
      // Limpiar el parámetro de la URL sin recargar
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  // Cerrar sidebar al cambiar de módulo (solo móvil)
  const handleModuleChange = (moduleId) => {
    // Navegar por el menú limpia el contexto de gasto de posventa (evita reabrir el modal)
    setPosventaCtx(null);
    setActiveModule(moduleId);
    setSidebarOpen(false); // Cerrar menú al seleccionar opción
  };

  // Abrir Posventa mostrando el gasto (facturas) de un apartamento concreto
  const verPosventaProyecto = (proyecto_id, proyecto_nombre, apartamento) => {
    setPosventaCtx({ proyecto_id, proyecto_nombre, apartamento });
    setActiveModule('posventa');
  };

  // Toggle del sidebar móvil
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Función para ver detalle de proyecto
  const verDetalleProyecto = (proyectoId) => {
    setSelectedProyecto(proyectoId);
    setActiveModule('detalle-proyecto');
  };

  // Función para volver a la lista
  const volverALista = () => {
    setSelectedProyecto(null);
    setActiveModule('lista-proyectos');
  };

  // Función para ver detalle de proveedor
  const verDetalleProveedor = (proveedorId) => {
    setSelectedProveedor(proveedorId);
    setActiveModule('detalle-proveedor');
  };

  // Función para volver a proveedores
  const volverAProveedores = () => {
    setSelectedProveedor(null);
    setActiveModule('proveedores');
  };

  // Función para ver detalle de hoja de vida (cartera)
  const verDetalleHojaVida = (hojaVidaId) => {
    setSelectedHojaVida(hojaVidaId);
    setActiveModule('detalle-hoja-vida');
  };

  // Función para volver a cartera
  const volverACartera = () => {
    setSelectedHojaVida(null);
    setActiveModule('cartera');
  };

  // Mapeo de módulos a componentes
  const renderModule = () => {
    switch (activeModule) {
      case 'subir-excel':
        return <SubirExcel />;

      case 'lista-proyectos':
        return (
          <ListaProyectos
            onModuleChange={setActiveModule}
            onVerDetalle={verDetalleProyecto}
          />
        );

      case 'proyectos-especiales':
        return <ProyectosEspeciales onVerDetalle={verDetalleProyecto} />;

      case 'proyectos-liquidados':
        return <ProyectosLiquidados onVerDetalle={verDetalleProyecto} />;

      case 'polizas':
        return <Polizas />;

      case 'detalle-proyecto':
        return (
          <DetalleProyecto
            proyectoId={selectedProyecto}
            onVolver={volverALista}
            onVerPosventa={verPosventaProyecto}
          />
        );

      case 'proveedores':
        return (
          <Proveedores onVerDetalle={verDetalleProveedor} />
        );

      case 'detalle-proveedor':
        return (
          <DetalleProveedor
            proveedorId={selectedProveedor}
            onVolver={volverAProveedores}
          />
        );

      case 'tipos-proveedor':
        return <TiposProveedor />;

      case 'pagos':
        return <Pagos />;

      case 'inventario-bodega':
        return <InventarioBodega />;

      case 'entradas-bodega':
        return <EntradasBodega />;

      case 'salidas-bodega':
        return <SalidasBodega />;

      case 'usuarios':
        return <Usuarios />;

      case 'cartera':
        return (
          <CarteraList onVerDetalle={verDetalleHojaVida} />
        );

      case 'detalle-hoja-vida':
        return (
          <HojaVidaDetalle
            hojaVidaId={selectedHojaVida}
            onVolver={volverACartera}
          />
        );

      case 'cuentas-cobro':
        return <CuentasCobro />;

      case 'contratos':
        return <Contratos />;

      case 'matriz-actividades':
        return <MatrizActividades />;

      case 'cotizaciones':
        return <Cotizaciones />;

      case 'ficha-ffe':
        return <FichaFFE />;

      case 'carrito-compras-general':
        return <CarritoComprasGeneral />;

      case 'planos':
        return <Planos />;

      case 'contabilidad':
        return <Contabilidad />;

      case 'residentes':
        return <Residentes />;

      case 'enchapes':
        return <Enchapes />;

      case 'conceptos-facturas':
        return <ConceptosFacturas />;

      case 'posventa':
        return <Posventa initialGastoProyecto={posventaCtx} />;

      case 'crm-gestion':
      case 'crm-hojas':
      case 'crm-dashboard':
        return <CRMComercial initialTab={activeModule === 'crm-dashboard' ? 'dashboard' : activeModule === 'crm-hojas' ? 'hojas' : 'gestion'} />;

      case 'formulas-carrito':
        return <FormulasCarrito />;

      case 'informe-cotizaciones':
        return <InformesComerciales initialTab="cotizaciones" />;

      case 'informe-fichaffe':
        return <InformesComerciales initialTab="fichaffe" />;

      case 'catalogo-ffe':
        return <CatalogoFFE />;

      case 'alertas':
        return <AlertasAdmin />;

      case 'mis-compromisos':
        return <MisCompromisos onAbrirProyecto={verDetalleProyecto} />;

      case 'cronograma-general':
        return (
          <CronogramaGeneral
            onModuleChange={setActiveModule}
            onVerDetalle={verDetalleProyecto}
          />
        );

      // ingenieros eliminado - ahora se usa solo residentes

      case 'facturas':
        return <Facturas />;

      case 'facturas-admin':
        return <Facturas tipoFactura="administrativa" />;

      case 'caja-menor':
        return <CajaMenor />;

      case 'caja-menor-administrativo':
        return <CajaMenorAdministrativo />;

      case 'seguimiento-comercial':
        return <SeguimientoComercial />;
      case 'marketing':
        return <Marketing />;
      case 'tecnico':
        return <Tecnico />;
      case 'tablero-gerencial':
        return <TableroGerencial />;

      case 'vista-financiera':
        return <VistaFinancieraGerencia />;

      default:
        return <SubirExcel />;
    }
  };

  // Obtener título del módulo activo
  const getModuleTitle = () => {
    const titles = {
      'subir-excel': 'Crear Proyecto',
      'lista-proyectos': 'Lista de Proyectos',
      'proyectos-especiales': 'Proyectos Especiales',
      'detalle-proyecto': 'Detalle del Proyecto',
      'proveedores': 'Proveedores e Invoices',
      'detalle-proveedor': 'Detalle del Proveedor',
      'pagos': 'Gestión de Pagos',
      'tipos-proveedor': 'Tipos de Proveedores',
      'inventario-bodega': 'Inventario de Bodega',
      'entradas-bodega': 'Entradas de Bodega',
      'salidas-bodega': 'Salidas de Bodega',
      'usuarios': 'Gestión de Usuarios',
      'cartera': 'Cartera',
      'detalle-hoja-vida': 'Hoja de Vida del Cliente',
      'cuentas-cobro': 'Cuentas de Cobro',
      'contratos': 'Contratos',
      'matriz-actividades': 'Matriz de Actividades',
      'cotizaciones': 'Cotizaciones',
      'ficha-ffe': 'Ficha FFE',
      'carrito-compras-general': 'Carrito de Compras General',
      'planos': 'Planos de Proyecto',
      'residentes': 'Residentes',
      'enchapes': 'Enchapes',
      'conceptos-facturas': 'Conceptos Facturas',
      'posventa': 'Posventa',
      'crm-gestion': 'CRM Comercial',
      'crm-hojas': 'CRM Comercial',
      'crm-dashboard': 'CRM Comercial',
      'formulas-carrito': 'Formulas Carrito',
      'informe-cotizaciones': 'Informes Comerciales',
      'informe-fichaffe': 'Informes Comerciales',
      'catalogo-ffe': 'Catalogo FFE',
      'alertas': 'Alertas y Correos',
      'cronograma-general': 'Cronograma General',
      'mis-compromisos': 'Mis Compromisos',
      'facturas': 'Facturas',
      'caja-menor': 'Caja Menor',
      'caja-menor-administrativo': 'Caja Menor - Administrativo',
      'seguimiento-comercial': 'Seguimiento Comercial'
    };
    return titles[activeModule] || 'TUVI';
  };

  // Mostrar loading mientras verifica sesión
  if (loading) {
    return (
      <div className="app-loading">
        <div className="app-loading-content">
          <div className="app-spinner"></div>
          <span className="loading-text">Cargando...</span>
        </div>
      </div>
    );
  }

  // Ruta especial: editor de planos full-screen (sin topbar / header)
  // Se abre en una nueva pestaña con ?params=... desde Ficha FFE.
  if (window.location.pathname === '/editor-planos') {
    return <EditorPlanos />;
  }

  return (
    <div className={`App ${sidebarOpen ? 'sidebar-open' : ''}`}>
      {/* Overlay para cerrar sidebar en móvil */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <Sidebar
        activeModule={activeModule}
        onModuleChange={handleModuleChange}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        user={user}
        onLogout={logout}
      />

      <div className="app-content">
        <Header
          title={getModuleTitle()}
          onToggleSidebar={toggleSidebar}
          sidebarOpen={sidebarOpen}
        />

        <main className="app-main">
          <div className={`content-wrapper ${MODULOS_ANCHOS.includes(activeModule) ? 'content-wrapper-wide' : ''}`}>
            {renderModule()}
          </div>
        </main>
      </div>
    </div>
  );
}

// Componente App con autenticación
function App() {
  const { isAuthenticated, login, loading } = useAuth();

  // Ruta de demo del configurador 3D (sin login) — solo para pruebas locales
  if (window.location.pathname === '/demo-3d') {
    return <Configurador3DDemo />;
  }

  // Mostrar loading mientras verifica sesión
  if (loading) {
    return (
      <div className="app-loading">
        <div className="app-loading-content">
          <div className="app-spinner"></div>
          <span className="loading-text">Verificando sesión...</span>
        </div>
      </div>
    );
  }

  // Mostrar login si no está autenticado
  if (!isAuthenticated) {
    return <Login onLogin={login} />;
  }

  return <AppContent />;
}

// Wrapper con AuthProvider y NotificationProvider
function AppWrapper() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <App />
      </NotificationProvider>
    </AuthProvider>
  );
}

export default AppWrapper;
